import React from "react";
import { ShopCard } from "../components/ShopCard/ShopCard";
import { Header } from "../components/Header/Header";

const ShoppingCardPage = () => {
  return (
    <div>
      <Header />
      <ShopCard />
    </div>
  );
};

export default ShoppingCardPage;
